import {Injectable} from '@angular/core';
import {AbstractControl, AsyncValidatorFn, ValidationErrors} from '@angular/forms';
import {Observable} from 'rxjs';
import {first, map} from 'rxjs/operators';
import {promise} from 'selenium-webdriver';
import {ProfileServiceHttp} from 'src/app/http-services/profile-service-http.service';

@Injectable()
export class NationalIdValidator {
	constructor(private profileService: ProfileServiceHttp) {
	}

	public uniqueNationalId(): AsyncValidatorFn {
		return (control: AbstractControl): Observable<ValidationErrors | null> => {
			return this.profileService.isNationalIdTaken(control.value)
				.pipe(
					map(res => {
						if (res.data) {
							return {'nationalIdExists': true};
						}
						return null;
					})
				).pipe(first());
		};
	}
}
